import React, { useEffect } from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';

import { uuidv4 } from 'common/uuidGenerator';
import { FormLabel, AssignToItemTemplate } from 'modules/automation/WorkflowBuilder/components';
import { Button } from 'primereact/button';
import { formatUserDropdown } from 'modules/automation/utils/formatUserDropdown';
import { automationModules } from 'constants/automation';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';

const TaskSubTask = (params) => {
  const { userList, index: mainIndex, isFirmUserLoading } = params || {};

  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();
  const trigger = watch('trigger') || {};
  const isForLeadAutomation =
    watch('is_lead_automation') || (trigger?.module === automationModules.LEADS && trigger?.code !== 'TRIG_LEAD_CONV_CASE');

  useEffect(() => {
    const dropdownClasses = document?.querySelectorAll('.p-multiselect-token');
    for (const dropdownElement of dropdownClasses) {
      const dropLabelElement = dropdownElement?.querySelector('.p-multiselect-token-label')?.innerHTML;

      if (dropLabelElement?.trim()?.length === 0) {
        dropdownElement.style.display = 'none';
      }
    }
  }, [userList]);

  const {
    fields: subTaskFields,
    append: appendSubTask,
    remove: removeSubTask,
  } = useFieldArray({
    control,
    name: `actions.${mainIndex}.subTask`, // unique name for Field Array
  });

  return (
    <div className="g-3">
      <FormLabel label="Sub Task" isRequired={false} className="p-medium py-3" />

      {subTaskFields?.length > 0 &&
        subTaskFields?.map((item, index) => (
          <div
            className="p-2 bg-card  mt-1 card-bg-color gap-3 d-flex justify-content-between align-items-center rounded shadow-sm w-100"
            key={item?.id}
          >
            <div className="w-50">
              <Controller
                name={`actions[${mainIndex}].subTask[${index}].sub_task_description`}
                rules={{ required: 'Required' }}
                control={control}
                render={({ field: { name, value, onChange } }) => (
                  <InputText value={value} name={name} className="input-shadow w-100" onChange={onChange} placeholder="Sub Task Name" />
                )}
              />
              <RequiredValidation errors={errors} field={`actions.${mainIndex}.subTask.${index}.sub_task_description`} />
            </div>

            <div className="w-50">
              <Controller
                name={`actions[${mainIndex}].subTask[${index}].assignTo`}
                rules={{ required: 'Required' }}
                control={control}
                render={({ field: { name, onChange, value } }) => (
                  <MultiSelect
                    name={name}
                    value={value ?? []}
                    options={
                      formatUserDropdown({
                        users: userList,
                        hideInactive: true,
                        includeContacts: false,
                        includesUserGroups: true,
                        includesTeamMembers: true,
                        includePrimarySecondary: true,
                        isLead: isForLeadAutomation,
                        includeSelectedInactiveUser: true,
                        includeSelectedInactiveUserGroup: true,
                        selectedItems: value || [],
                      }) || []
                    }
                    placeholder="Please Select Assignees"
                    className="w-100 p-dropdown p-component p-inputwrapper"
                    isFilter={true}
                    onChange={(e) => onChange(e.value)}
                    display="chip"
                    optionLabel="label"
                    optionGroupLabel="groupLabel"
                    optionGroupChildren="items"
                    optionValue={(v) => ({ value: v?.value, res_type: v?.res_type })} // Do not change, if changing update in parse automation and payload util functions
                    itemTemplate={AssignToItemTemplate}
                    dropdownIcon={isFirmUserLoading ? 'pi pi-spin pi-spinner' : undefined}
                  />
                )}
              />
              <RequiredValidation errors={errors} field={`actions.${mainIndex}.subTask.${index}.assignTo`} />
            </div>

            <Button
              tooltip="Remove Sub Task"
              tooltipOptions={{ showDelay: 500, position: 'left' }}
              icon="pi pi-trash danger-text"
              className="p-button-rounded p-button-text text-danger p-3"
              onClick={() => removeSubTask(index)}
            />
          </div>
        ))}

      <div
        className="mt-2 pointer call-back"
        onClick={() =>
          appendSubTask({
            sub_task_description: '',
            sub_task_status: false,
            sk: uuidv4(),
          })
        }
      >
        <i className="icon-add"></i> Add Sub Task
      </div>
    </div>
  );
};

export default TaskSubTask;
